import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for Awards
 */

export default defineSlotRecipe({
    slots: [
        'root',
        'backgroundLayer',
        'backgroundImage',
        'content',
        'awardsGroup',
        'award',
        'awardImage',
        'awardText',
        'copy'
    ],
    base: {
        root: {
            position: 'relative',
            width: '100%'
        },
        backgroundLayer: {
            position: 'absolute',
            // negate the container padding and max-width gutter to fill the whole module box
            insetBlockStart: 'calc(var(--container-block-padding-start, 0px) * -1)',
            insetBlockEnd: 'calc(var(--container-block-padding-end, 0px) * -1)',
            insetInline: 'calc(var(--container-total-inline-padding, 0px) * -1)',
            overflow: 'hidden',
            zIndex: 0,
            pointerEvents: 'none'
        },
        // height follows the asset ratio, so a shorter asset deliberately leaves the module
        // background visible; centring keeps both the crop and that gap symmetric
        backgroundImage: {
            position: 'absolute',
            insetBlockStart: '50%',
            insetInlineStart: 0,
            transform: 'translateY(-50%)',
            width: '100%',
            height: 'auto'
        },
        content: {
            position: 'relative',
            zIndex: 1,
            maxWidth: {s: '8/12'},
            marginX: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'spacing-32'
        },
        copy: {
            textAlign: 'center'
        },
        awardsGroup: {
            display: 'flex',
            flexDirection: 'row',
            paddingTop: {base: 'spacing-16', s: 'spacing-48'},
            paddingX: {base: 'spacing-16', s: 'spacing-64'},
            gap: {base: 'spacing-16', s: 'spacing-48'}
        },
        award: {
            display: 'grid',
            gridTemplateRows: {
                base: '6.75rem auto',
                s: '8.7rem auto'
            },
            justifyItems: 'center',
            gap: 'spacing-24',
            paddingX: {base: 'spacing-16', s: 'spacing-32'},
            '&:nth-of-type(3)': {display: {base: 'none', s: 'grid'}},
            '&:nth-of-type(n+4)': {display: 'none'}
        },

        awardImage: {
            width: {base: '6.75rem', s: '8.7rem'},
            height: {base: '6.75rem', s: '8.7rem'},
            objectFit: 'contain'
        },

        awardText: {
            color: 'text.primary',
            textStyle: 'display.xsmall',
            textAlign: 'center',
            width: {base: '6.75rem', s: '8.7rem'}
        }
    },
    variants: {
        copySize: {
            default: {
                copy: {textStyle: 'display.xsmall'}
            },
            emphasized: {
                copy: {textStyle: 'display.medium'}
            }
        }
    },
    defaultVariants: {
        copySize: 'default'
    }
})
